import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { deserialize } from 'santee-dcts';
import { UserPreferencesStorage } from '../user-preferences/user-preferences-storage';
import { map } from 'rxjs/operators';
import { WorkspaceDrawerBehavior, drawerBehaviorKey } from './workspace-drawer-behavior';

@Injectable()
export class WorkspaceDrawerBehaviorResolver implements Resolve<WorkspaceDrawerBehavior> {

    constructor(private readonly userPreferencesStorage: UserPreferencesStorage) { }

    public resolve(): Observable<WorkspaceDrawerBehavior | null> {
        return this.userPreferencesStorage
            .get(drawerBehaviorKey)
            .pipe(
                map(this.parseDrawerBehavior)
            );
    }

    private parseDrawerBehavior = (value: string): WorkspaceDrawerBehavior | null => {
        try {
            if (!value) {
                return null;
            }

            const behaviorRaw = JSON.parse(value);
            const behavior = deserialize(behaviorRaw, WorkspaceDrawerBehavior);

            return behavior;
        } catch (e) {
            return null;
        }
    }
}
